<template>
  <v-dialog :persistent="exporting" v-model="dialog" width="800">
    <template v-slot:activator="{ on }">
      <v-btn
        :icon="iconOnly"
        :color="buttonColor"
        v-on="on"
        :disabled="isReadyToExport"
        v-bind="{ [size]: true }"
      >
        <v-icon v-if="buttonIconName != null">{{ buttonIconName }}</v-icon>
        <span v-else>{{ buttonName }}</span>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="cardheader">
        <span class="black--text text-h5">Export ...</span>
      </v-card-title>
      <v-card-text class="mt-2">
        <v-container>
          <v-row class="d-flex align-center justify-center">
            <div v-if="exporting">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
              <span>
                Exporting {{ exportType ? `as ${exportType}` : '' }} ...
              </span>
            </div>
            <div v-else>
              <v-btn
                color="primary"
                :disabled="isReadyToExport"
                @click="downloadPDF()"
              >
                Export as PDF
              </v-btn>
              <v-btn
                class="ml-2"
                color="primary"
                :disabled="isReadyToExport"
                @click="downloadSVG()"
              >
                Export as SVG
              </v-btn>
            </div>
          </v-row>
          <v-row class="mt-4"
            ><span class="grey--text"
              ><i
                >Text will not be selectable when exporting to PDF.<br />
                3-dimensional plots will not be exported.<br />
                Page may become temporarly unresponsive during export.<br /></i></span
          ></v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import { elementToSVG, inlineResources } from 'dom-to-svg'
import svgStyle from './svgStyle'

export default {
  name: 'ComponentExporter',
  mixins: [],
  components: {},
  props: {
    elementToExport: {
      type: Element,
      default: null
    },
    buttonName: {
      type: String,
      default: 'Export ...'
    },
    buttonIconName: {
      type: String,
      default: null
    },
    iconOnly: {
      type: Boolean,
      default: false
    },
    buttonColor: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {
      dialog: false,
      exporting: false,
      exportType: null
    }
  },

  watch: {},

  mounted() {},

  computed: {
    isReadyToExport() {
      return this.HTMLElementToExport != null
    },
    backgroundColor() {
      return this.$vuetify.theme.dark ? 'rgb(18, 18, 18)' : 'white'
    }
  },

  methods: {
    async downloadSVG() {
      this.exporting = true
      this.exportType = 'SVG'

      const previousBackgroundColor =
        this.elementToExport.style.getPropertyValue('background')
      this.elementToExport.style.setProperty('background', this.backgroundColor)
      const svgDocument = elementToSVG(this.elementToExport)
      this.elementToExport.style.setProperty(
        'background',
        previousBackgroundColor
      )

      inlineResources(svgDocument.documentElement)
        .then(() => {
          let svgString = new XMLSerializer().serializeToString(svgDocument)
          svgString = svgString.replace('<style/>', svgStyle)
          var myblob = new Blob([svgString], {
            type: 'text/plain'
          })
          this.downloadFromURI(
            window.URL.createObjectURL(
              new Blob([myblob], {
                type: 'application/octet-stream'
              })
            ),
            (this?.currentMission?.name ?? 'evasive') + '.svg'
          )
        })
        .finally(() => this.resetAndClose())
    },
    async downloadPDF() {
      this.exporting = true
      this.exportType = 'PDF'
      const content = this.elementToExport

      const orientation = content.offsetWidth > content.offsetHeight ? 'l' : 'p'

      const doc = new jsPDF({
        orientation: orientation,
        unit: 'px',
        format: [content.offsetWidth, content.offsetHeight],
        hotfixes: ['px_scaling']
      })

      html2canvas(content, {
        dpi: 300,
        scale: 2,
        width: content.offsetWidth,
        height: content.offsetHeight,
        backgroundColor: this.backgroundColor
      }).then((canvas) => {
        const img = canvas.toDataURL('image/jpeg', 1)
        doc.addImage(
          img,
          'JPEG',
          0,
          0,
          content.offsetWidth,
          content.offsetHeight
        )

        this.downloadFromURI(
          window.URL.createObjectURL(
            new Blob([doc.output('arraybuffer')], {
              type: 'application/octet-stream'
            })
          ),
          (this?.currentMission?.name ?? 'evasive') + '.pdf'
        )
        this.resetAndClose()
      })
    },
    downloadFromURI(uri, name) {
      let a = window.document.createElement('a')
      a.href = uri
      a.download = name
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    resetAndClose() {
      this.dialog = false
      this.exporting = false
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');

.cardheader {
  background: #3be287;
}
</style>
